import { render, staticRenderFns } from "./PaymentPurchaseConfirmation.vue?vue&type=template&id=5a0149ba&scoped=true"
import script from "./PaymentPurchaseConfirmation.vue?vue&type=script&lang=ts"
export * from "./PaymentPurchaseConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./PaymentPurchaseConfirmation.vue?vue&type=style&index=0&id=5a0149ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0149ba",
  null
  
)

export default component.exports